import React, {FunctionComponent} from 'react'
import {useTranslation} from 'react-i18next'
import  { IProps }  from './IProps'

const Header: FunctionComponent<IProps> = ({result}) => {
    const {t} = useTranslation()

    return <thead>
    <tr>
        <th className={'text-left'}>{t('Date')}</th>
        <th className={'text-left'}>{t('Description')}</th>
        <th className={'text-right'}>{t('Totals')}</th>
        {result.vatPercentages.map(
          (vatPercentage, index) => <th key={'vat' + index} className={'text-right'}>{vatPercentage} %</th>
        )}
    </tr>
    </thead>
}

export default Header
